import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {InlineSVGModule} from 'ng-inline-svg-2';
import {LayoutScrollTopComponent} from './scroll-top/scroll-top.component';
import {TranslationModule} from '../../../../modules/i18n';
import {SearchResultInnerComponent} from "./dropdown-inner/search-result-inner/search-result-inner.component";
import {NgbDatepickerModule, NgbTimepickerModule, NgbTooltipModule} from "@ng-bootstrap/ng-bootstrap";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import { SharedModule } from "../../../shared/shared.module";
import { UserInnerComponent } from './dropdown-inner/user-inner/user-inner.component';
import { ScheduleTreeComponent } from './schedule-tree/schedule-tree.component';
import { DateTimePickerComponent } from './date-time-picker/date-time-picker.component';
import { MaterialsModule } from 'src/app/modules/materials/materials.module';
import { CheckboxGroupComponent } from './checkbox-group/checkbox-group.component';
import { FullcalendarComponent } from './fullcalendar/fullcalendar.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import { SelectionInputTreeComponent } from './selection-input-tree/selection-input-tree.component';
import { ModalsModule } from '../modals/modals.module';
import { OverrideModalComponent } from './fullcalendar/override-modal/override-modal.component';
import { OffcanvasComponent } from './offcanvas/offcanvas.component';

@NgModule({
  declarations: [
    SearchResultInnerComponent,
    UserInnerComponent,
    LayoutScrollTopComponent,
    ScheduleTreeComponent,
    DateTimePickerComponent,
    CheckboxGroupComponent,
    FullcalendarComponent,
    SelectionInputTreeComponent,
    OverrideModalComponent,
    OffcanvasComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    InlineSVGModule,
    RouterModule,
    TranslationModule,
    NgbTooltipModule,
    SharedModule,
    MaterialsModule,
    ModalsModule,
    ReactiveFormsModule,
    FormsModule,
    NgbDatepickerModule,
    NgbTimepickerModule,
    FullCalendarModule
  ],
  exports: [
    SearchResultInnerComponent,
    UserInnerComponent,
    LayoutScrollTopComponent,
    ScheduleTreeComponent,
    DateTimePickerComponent,
    CheckboxGroupComponent,
    FullcalendarComponent,
    SelectionInputTreeComponent,
    OffcanvasComponent
  ],
})
export class ExtrasModule {
}
